import React from 'react';
import { useNavigate } from 'react-router-dom';

const WordGame: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ marginBottom: 16 }}>단어 게임</h1>
      <button type="button" onClick={() => navigate('/class/teacher/ClassManagementHome')} style={{ padding: '8px 16px', cursor: 'pointer' }}>학급 홈으로</button>
      <p style={{ color: '#666', fontSize: 14, marginTop: 16 }}>전체 기능은 .full.tsx 복구 후 사용 가능합니다.</p>
    </div>
  );
};

export default WordGame;
